export default {
  nethrisEmployeurD: {
    TITLE: `Nethris/EmployeurD`,
    REGULAREARNINGCODE: {
      LABEL: `Regular earning code`,
      PLACEHOLDER: `Enter a code starting with the letter G`,
      DESCRIPTION: ``
    },
    HOURLYRATE: {
      LABEL: `Hourly rate`,
      PLACEHOLDER: `Enter a code`,
      DESCRIPTION: ``
    },
    DIVISION: {
      LABEL: `Division`,
      PLACEHOLDER: `Enter a code`,
      DESCRIPTION: ``
    },
    SERVICE: {
      LABEL: `Service`,
      PLACEHOLDER: `Enter a code`,
      DESCRIPTION: ``
    },
    DEPARTMENT: {
      LABEL: `Department`,
      PLACEHOLDER: `Enter a code`,
      DESCRIPTION: ``
    },
    SUBDEPARTMENT: {
      LABEL: `Sub department`,
      PLACEHOLDER: `Enter a code`,
      DESCRIPTION: ``
    },
    WORKS1: {
      LABEL: `Work code S1`,
      PLACEHOLDER: `Enter a code`,
      DESCRIPTION: ``
    },
    WORKS2: {
      LABEL: `Work code S2`,
      PLACEHOLDER: `Enter a code`,
      DESCRIPTION: ``
    }
  },
  apogee: {
    TITLE: 'Apogée',
    FUNCCODE: {
      LABEL: `Func-Code`,
      PLACEHOLDER: `Enter a code`,
      DESCRIPTION: ``
    },
    FUNCTLEVEL: {
      LABEL: `Funct-Level`,
      PLACEHOLDER: `Enter a code`,
      DESCRIPTION: ``
    }
  }
}
